import { adminAxiosInstance } from "./adminAxiosInstance";

const CACHE_TTL = 2 * 60 * 1000;
const overviewCache = new Map();
const overviewRequests = new Map();
const number = (value) => Number(value || 0);

const normalizeMarketingOverview = (response = {}) => ({
  status: response.status !== false,
  message: response.message,
  start_date: response.start_date || null,
  end_date: response.end_date || null,
  interval: response.interval || null,
  buyer_composition: {
    total_active_buyers: number(response.buyer_composition?.total_active_buyers ?? response.buyer_metrics?.total_active_buyers),
    registered_buyers_count: number(response.buyer_composition?.registered_buyers_count ?? response.buyer_metrics?.registered_buyers_count),
    guest_buyers_count: number(response.buyer_composition?.guest_buyers_count ?? response.buyer_metrics?.guest_buyers_count),
    registered_buyers_percentage: number(response.buyer_composition?.registered_buyers_percentage ?? response.buyer_metrics?.registered_buyers_percentage),
    guest_buyers_percentage: number(response.buyer_composition?.guest_buyers_percentage ?? response.buyer_metrics?.guest_buyers_percentage),
  },
  buyer_growth_summary: {
    growth_rate_percentage: number(response.buyer_growth_summary?.growth_rate_percentage),
    growth_rate_label: response.buyer_growth_summary?.growth_rate_label || null,
    net_growth_count: number(response.buyer_growth_summary?.net_growth_count),
    net_growth_label: response.buyer_growth_summary?.net_growth_label || null,
    start_period_name: response.buyer_growth_summary?.start_period_name || null,
    current_active_buyers: number(response.buyer_growth_summary?.current_active_buyers),
    starting_active_buyers: number(response.buyer_growth_summary?.starting_active_buyers),
  },
  chart_data: (Array.isArray(response.chart_data) ? response.chart_data : []).map((item) => ({
    period: item.period,
    label: item.label || item.period,
    active_buyers: number(item.active_buyers),
  })),
});

export const getAdminMarketingOverview = ({ startDate, endDate } = {}) => {
  const key = `${startDate || "default"}:${endDate || "default"}`;
  const cached = overviewCache.get(key);
  if (cached && Date.now() - cached.updatedAt < CACHE_TTL) return Promise.resolve(cached.data);
  if (overviewRequests.has(key)) return overviewRequests.get(key);

  const request = adminAxiosInstance
    .get("/admin/internal/marketing/overview/stats", {
      params: {
        ...(startDate ? { startDate } : {}),
        ...(endDate ? { endDate } : {}),
      },
    })
    .then(({ data }) => {
      const result = normalizeMarketingOverview(data);
      if (!result.status) throw new Error(result.message || "Marketing overview could not be loaded.");
      overviewCache.set(key, { data: result, updatedAt: Date.now() });
      return result;
    })
    .finally(() => overviewRequests.delete(key));

  overviewRequests.set(key, request);
  return request;
};

export const clearAdminMarketingOverviewCache = () => {
  overviewCache.clear();
  overviewRequests.clear();
};
